import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class RadioButton extends Component {
  render () {
    return (
      <label className={classNames('group relative cursor-pointer inline-flex items-center', this.props.className)}>
        <input type="radio" className="absolute -left-max" value={this.props.value} checked={this.props.checked} onChange={this.props.onChange && this.props.onChange} />

        <span className={classNames('w-6 h-6 rounded-1/2 p-0.5 block overflow-hidden border mr-6')}>
          <span className={classNames('transition-colors duration-150 ease-in-out block w-full h-full rounded-1/2', { 'bg-green': this.props.checked })}></span>
        </span>

        <span className="flex-shrink-0 flex-grow-0">
          {this.props.label}
        </span>
      </label>
    )
  }
}

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default RadioButton
